export const STUDENT_UPDATE_SELECTED_LAB = "STUDENT_UPDATE_SELECTED_LAB";
export const STUDENT_UPDATE_SELECTED_PROGRAM = "STUDENT_UPDATE_SELECTED_PROGRAM";
export const STUDENT_UPDATE_SELECTED_SUBMISSION = "STUDENT_UPDATE_SELECTED_SUBMISSION";